import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ArrowRightImage from '../assets/images/arrow--right.svg'
import ArrowRightHoverImage from '../assets/images/arrow--right-hover.svg'
import ArrowRightActiveImage from '../assets/images/arrow--right-active.svg'

const fontSizeChooser = ({ theme, size }) => {
  switch (size) {
    case 'small':
      return theme.fontSize(2.1)
    default:
      return theme.fontSize(3.5)
  }
}

const heightChooser = ({ size }) => {
  switch (size) {
    case 'small':
      return '4.2rem'
    default:
      return '7rem'
  }
}

const widthChooser = ({ size }) => {
  switch (size) {
    case 'small':
      return '7.8rem'
    default:
      return '13rem'
  }
}

const Container = styled(Link)`
  animation: ${p =>
      p.animateSideToSide ? p.theme.animation.sideToSide : 'none'}
    2s infinite;
  animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
  align-items: center;
  background-image: url(${ArrowRightImage});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100%;
  color: ${p => p.theme.color.Button.copy};
  display: inline-flex;
  font-family: ${props => props.theme.fontFamily.primary};
  font-size: ${fontSizeChooser};
  height: ${heightChooser};
  justify-content: center;
  letter-spacing: 0.1rem;
  line-height: 100%;
  padding-right: 0.35em;
  padding-top: 0.05em;
  position: relative;
  text-transform: uppercase;
  width: ${widthChooser};
  letter-spacing: -0.005em;

  &:hover {
    background-image: url(${ArrowRightHoverImage});
  }

  &:active {
    background-image: url(${ArrowRightActiveImage});
  }
`

export default class ButtonArrow extends Component {
  render() {
    const { children, animateSideToSide, ...props } = this.props

    return (
      <Container animateSideToSide={animateSideToSide} {...props}>
        {children}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ButtonArrow.js